import {POST} from "@/services/gateway";

const listBackups = ({pagination, sharedFolderIds, filter}) => {
  return POST('backup/list', {pagination, sharedFolderIds, filter})
}

export {
  listBackups
}
